import { BaseSelectors } from '@makemydeal/dr-activities-common';
import type { DealType, IncentiveType } from '@makemydeal/dr-shared-bff-types';
import type { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import type { AdditionalSelectors, RequestProposalState } from '../types';

type RootStateWithProposal = { requestProposal: RequestProposalState };

/**
 * Carries the host-provided AdditionalSelectors into the activity's store singletons
 * (dependency injection). Mirrors the dealership-picker Selectors class.
 */
export class Selectors extends BaseSelectors {
    constructor(public sliceName: string, public additionalSelectors: AdditionalSelectors) {
        super(sliceName);
    }
}

export const getSelectedDealTypes = (state: RootStateWithProposal): DealType[] => state.requestProposal.selectedDealTypes;

export const getSelectedIncentives = (state: RootStateWithProposal): IncentiveType[] => state.requestProposal.selectedIncentives;

export const getNotes = (state: RootStateWithProposal): string => state.requestProposal.notes;

export const getRequestStatus = (state: RootStateWithProposal): RequestProposalState['requestStatus'] =>
    state.requestProposal.requestStatus;

export const getIsRequestChangeModalOpen = (state: RootStateWithProposal): boolean =>
    state.requestProposal.isRequestChangeModalOpen;

export const getDealPdfUrl = (state: RootStateWithProposal): string | undefined => state.requestProposal?.dealPdfUrl;

/** The dealXgVersion `dealPdfUrl` was fetched for */
export const getDealPdfVersion = (state: RootStateWithProposal): string | undefined => state.requestProposal?.dealPdfVersion;

/** Whether a dealPdf fetch is in flight */
export const getDealPdfFetchStatus = (state: RootStateWithProposal): ApiRequestStatus | undefined =>
    state.requestProposal?.dealPdfFetchStatus;

export const getShowConfetti = (state: RootStateWithProposal): boolean => state.requestProposal.showConfetti;
export const getPdfLoadingStatus = (state: RootStateWithProposal): boolean => state.requestProposal.isDealPdfLoading;
